import React, { FC } from 'react'

import { AutoStoryPopoverContentProps, TypedAutoStoryPopoverContentProps } from './AutoStoryPopoverContent.props'

import './AutoStoryPopoverContent.scss'
import { useZoneManager } from '../../../../shared/hooks/useZoneManager'

export const AutoStoryPopoverContent: FC<AutoStoryPopoverContentProps> = ({ type }) => {
  const { currentZone } = useZoneManager()
  const countryCodes = currentZone?.countryCodes || []
  return type === 'radio' ? (
    <RadioAutoStoryPopoverContent countryCodes={countryCodes} />
  ) : (
    <DSPAutoStoryPopoverContent countryCodes={countryCodes} />
  )
}

export const RadioAutoStoryPopoverContent: FC<TypedAutoStoryPopoverContentProps> = ({ countryCodes }) => (
  <div className="story__popover-content">
    <div>
      <span>Radio updates:</span> weekly on Mondays at 1 AM UTC
    </div>
    <div>
      <span>Data source:</span> radiomonitor.com through WMG Data Factory
    </div>
    <div>
      <span>Monitored countries:</span> {countryCodes.join(', ')}
    </div>
    <div>
      <p>This is a work in progress, and we need your help to make it great.</p>
      <p>If you have recommendations, please get in touch with maria.dilling@warnermusic.com.</p>
    </div>
  </div>
)

export const DSPAutoStoryPopoverContent: FC<TypedAutoStoryPopoverContentProps> = ({ countryCodes }) => (
  <div className="story__popover-content">
    <div>
      <span>Priority playlist updates:</span> Daily at 12 PM UTC
    </div>
    <div>
      <span>Monitored countries:</span> Global, {countryCodes.join(', ')}
    </div>
    <div>
      <span>Monitored DSPs:</span> Spotify, Apple Music, Deezer
    </div>
    <div>
      <p>
        The frequency of updates will improve, and the list of playlists will grow, but we need your help to make it
        great.
      </p>
      <p>
        If you would like to see specific playlists or have recommendations, please contact
        maria.dilling@warnermusic.com.
      </p>
    </div>
  </div>
)

export default AutoStoryPopoverContent
